import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CaretDown } from '@phosphor-icons/react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { SelectDriverFilter } from '../../components/FrotaFormularioComponents/SelectDriverFilter';
import { SelectManagerFilter } from '../../components/FrotaFormularioComponents/SelectManagerFilter';

export function RegisterVehicle() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [dataEntrega, setDataEntrega] = useState(new Date());
  const [dataDevolucao, setDataDevolucao] = useState(new Date());
  const [loading, setLoading] = useState(false);

  // Estados para dados de seleção
  const [estados, setEstados] = useState([]);
  const [tiposVeiculo, setTiposVeiculo] = useState([]);
  const [tiposCombustivel, setTiposCombustivel] = useState([]);
  // const [gestores, setGestores] = useState([]);
  // const [tecnicos, setTecnicos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [situacoes, setSituacoes] = useState([]);
  const [empresasCartao, setEmpresasCartao] = useState([]);
  const [empresasRastreador, setEmpresasRastreador] = useState([]);

  const [employee, setEmployee] = useState(0);
  const [manager, setManager] = useState(0);

  const [tiposContrato, setTiposContrato] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [tags, setTags] = useState([]);

  const [codigoCliente, setCodigoCliente] = useState([]);
  const [locadoras, setLocadoras] = useState([]);
  const [centroCustoTicketlog, setCentroCustoTicketlog] = useState([]);

  const [codigoResponsavelVeiculoTl, setCodigoResponsavelVeiculoTl] = useState([]);
  const [filtroResponsavel, setFiltroResponsavel] = useState('');
  const [showDropdownResponsavel, setShowDropdownResponsavel] = useState(false);

  const [codigoGrupoRestricaoTl, setCodigoGrupoRestricaoTl] = useState([]);
  const [modelos, setModelos] = useState([]);
  // PARA TESTE
  const [formData, setFormData] = useState({
    estado_id: 1,
    placa: 'RXX6X99',
    ano_fabricacao: 2021,
    ano_modelo: 2022,
    renavam: '01304137999',
    chassi: '9UWSHX76ANN033599',
    modelo: 'KIA I/KIA UK2500 HD SC',
    motorizacao: '1.6',
    marca_id: 1,
    locadora_id: 1,
    data_entrega: '2025-05-01',
    data_devolucao: '2025-06-30',
    capacidade_tanque: 44,
    km_inicial: 30000,
    descricao: 'Motor 1.9',
    cor: 'AZUL',
    tag_id: null,
    inicio_contrato: '2025-06-11',
    fim_contrato: '2025-06-17',
    valor_contrato: 1250,
    gestor_id: 3389396,
    condutor_id: 3389396,
    situacao_id: 1,
    empresa_id: 0,
    status: true,
    rastreador_empresa_id: null,
    empresa_cartao_combustivel_id: 1,
    conectado_cartao_combustivel: false,
    valor_cartao: 100,
    cartao_associado: '',
    usuario: 'admin',
    codigo_cliente_tl: null,
    familia_veiculo_tl: 1,
    tipo_combustivel_tl: 1,
    codigo_responsavel_veiculo_tl: null,
    tipo_frota_tl: 1,
    codigo_grupo_restricao_tl: null,
    codigo_cc_tl: null,
    fabricante: '',
  });

  // const [formData, setFormData] = useState({
  //   estado_id: 0,
  //   placa: '',
  //   ano_fabricacao: 0,
  //   renavam: '',
  //   chassi: '',
  //   modelo: '',
  //   marca: '',
  //   locadora: '',
  //   data_entrega: new Date().toISOString().split('T')[0],
  //   data_devolucao: new Date().toISOString().split('T')[0],
  //   descricao: '',
  //   cor: '',
  //   tipo_combustivel_tl: 0,
  //   tipo_frota_tl: 0,
  //   inicio_contrato: new Date().toISOString().split('T')[0],
  //   fim_contrato: new Date().toISOString().split('T')[0],
  //   valor_contrato: 0,
  //   familia_veiculo_tl: 0,
  //   gestor_id: 0,
  //   gestor_id: '',
  //   tecnico_id: 0,
  //   tecnico_nome: '',
  //   empresa_id: 0,
  //   situacao_id: 0,
  //   status: true,
  //   rastreador_empresa_id: 0,
  //   empresa_cartao_combustivel_id: 0,
  //   conectado_cartao_combustivel: false,
  //   valor_cartao: 0,
  //   cartao_associado: '',
  //   tag_id: '',
  //   usuario: 'admin',
  //   capacidade_tanque: 0,
  //   km_inicial: 0,
  // });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.relative')) {
        setShowDropdownResponsavel(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const response1 = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/tipo-frota/${formData.codigo_cliente_tl}/4`
        );
        setTiposContrato(response1.data.informacoes);

        const response2 = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/informacao-adicional/${formData.codigo_cliente_tl}/4`
        );
        setCentroCustoTicketlog(response2.data.informacaoAdicional1.informacoes);

        const response3 = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/veiculo-responsavel/${formData.codigo_cliente_tl}/4`
        );

        setCodigoResponsavelVeiculoTl(response3.data.informacoes);

        const response4 = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/grupo-restricao/${formData.codigo_cliente_tl}/4`
        );
        setCodigoGrupoRestricaoTl(response4.data.informacoes);
      } catch (error) {
        console.error('Erro na requisição:', error);
      }
    }

    if (formData.codigo_cliente_tl) {
      fetchData();
    }
  }, [formData.codigo_cliente_tl]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response1 = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/modelo/${formData.marca_id}`
        );

        setModelos(response1.data.modelos);
      } catch (error) {
        console.error('Erro na requisição:', error);
      }
    }

    if (formData.marca_id) {
      fetchData();
    }
  }, [formData.marca_id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setCodigoCliente(
          (
            await axios.get(
              'https://radar.tlpservicos.com.br/api/veiculos/es/codigo-cliente'
            )
          ).data
        );
        setEstados(
          (await axios.get('https://radar.tlpservicos.com.br/api/veiculos/es/estado'))
            .data
        );
        setMarcas(
          (
            await axios.get(
              'https://radar.tlpservicos.com.br/api/veiculos/es/fabricantes'
            )
          ).data.informacoesVeiculoVo
        );
        setTiposVeiculo(
          (
            await axios.get(
              'https://radar.tlpservicos.com.br/api/veiculos/es/familia-veiculos'
            )
          ).data
        );

        setLocadoras(
          (await axios.get('https://radar.tlpservicos.com.br/api/veiculos/es/locadoras'))
            .data
        );
        setEmpresas(
          (await axios.get('https://radar.tlpservicos.com.br/api/veiculos/es/empresas'))
            .data
        );

        setSituacoes(
          (
            await axios.get(
              'https://radar.tlpservicos.com.br/api/veiculos/es/situacao-veiculo'
            )
          ).data
        );
        setEmpresasRastreador(
          (
            await axios.get(
              'https://radar.tlpservicos.com.br/api/veiculos/es/rastreadores-empresa'
            )
          ).data
        );
        setTags(
          (await axios.get('https://radar.tlpservicos.com.br/api/veiculos/es/tag')).data
        );

        setTiposCombustivel(
          (
            await axios.get(
              'https://radar.tlpservicos.com.br/api/veiculos/es/combustiveis'
            )
          ).data
        );

        // );
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
        toast.error('Erro ao carregar informações necessárias');
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'number' ? Number(value) : value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const marcaSelecionada = marcas.find(
      (marca) => marca.codigo.toString() === formData.marca_id.toString()
    );

    try {
      let dataToSubmit = {
        ...formData,
        inicio_contrato: startDate
          ? startDate.toISOString().split('T')[0]
          : new Date().toISOString().split('T')[0],
        fim_contrato: endDate
          ? endDate.toISOString().split('T')[0]
          : new Date().toISOString().split('T')[0],
        data_entrega: dataEntrega
          ? dataEntrega.toISOString().split('T')[0]
          : new Date().toISOString().split('T')[0],
        data_devolucao: dataDevolucao
          ? dataDevolucao.toISOString().split('T')[0]
          : new Date().toISOString().split('T')[0],
      };
      dataToSubmit = {
        ...formData,
        tipo_frota_tl: Number(formData.tipo_frota_tl.split('-')[0]),
        empresa_cartao_combustivel_id: Number(formData.empresa_cartao_combustivel_id),
        fabricante: marcaSelecionada ? marcaSelecionada.descricao : '',
      };

      const response = await axios.post(
        'https://radar.tlpservicos.com.br/api/veiculos',
        dataToSubmit,
        {
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success('Veículo cadastrado com sucesso!');
      } else {
        toast.error('Erro ao cadastrar veículo');
      }
    } catch (error) {
      console.error('Erro ao enviar dados:', error);
      toast.error('Erro ao cadastrar veículo. Verifique os dados e tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 rounded-md shadow dark:bg-gray-350 mx-2">
      <h1 className="text-2xl font-semibold mb-6">Cadastrar Veículo</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-gray-300 p-4 rounded-md">
          <h2 className="text-lg font-medium mb-4">Dados cadastrais TicketLog</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Código de Cliente*
              </label>
              <div className="relative">
                <select
                  name="codigo_cliente_tl"
                  value={formData.codigo_cliente_tl}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-600 bg-gray-250 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 [color-scheme:light]"
                  style={{ colorScheme: 'light' }}
                  required
                >
                  <option value="0">Selecione</option>
                  {codigoCliente.map((item) => (
                    <option key={item.id} value={item.codigo}>
                      {`${item.codigo
                        .toString()
                        .padStart(6, '0')} - ${item.descricao.toUpperCase()}`}
                    </option>
                  ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-300 p-4 rounded-md">
          <h2 className="text-lg font-medium mb-4">Informações do Veículo</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Placa*
              </label>
              <input
                type="text"
                name="placa"
                maxLength={7}
                value={formData.placa}
                onChange={handleChange}
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:italic placeholder:font-light placeholder:text-gray-400"
                placeholder="ex: ABC1D23"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Estado*
              </label>
              <div className="relative">
                <select
                  name="estado_id"
                  value={formData.estado_id}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-600 bg-gray-250 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 [color-scheme:light]"
                  style={{ colorScheme: 'light' }}
                  required
                >
                  <option value="0">Selecione</option>
                  {estados.map((estado) => (
                    <option key={estado.id} value={estado.id}>
                      {`${estado.sigla} - ${estado.nome}`}
                    </option>
                  ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Ano de Fabricação*
              </label>
              <input
                type="number"
                name="ano_fabricacao"
                value={formData.ano_fabricacao || ''}
                onChange={handleChange}
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:italic placeholder:font-light placeholder:text-gray-400"
                placeholder="ex: 2023"
                min="1900"
                max="2026"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Renavam*
              </label>
              <input
                type="text"
                name="renavam"
                maxLength={11}
                value={formData.renavam}
                onChange={handleChange}
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:italic placeholder:font-light placeholder:text-gray-400"
                placeholder="ex: 01304137969"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Chassi*
              </label>
              <input
                type="text"
                name="chassi"
                maxLength={17}
                value={formData.chassi}
                onChange={handleChange}
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:italic placeholder:font-light placeholder:text-gray-400 uppercase"
                placeholder="ex: 9BWZZZ377VT004251"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Tipo de Veículo*
              </label>
              <div className="relative">
                <select
                  name="familia_veiculo_tl"
                  value={formData.familia_veiculo_tl}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="0">Selecione</option>
                  {tiposVeiculo.map((tipo) => (
                    <option key={tipo.id} value={tipo.codigo}>
                      {`${tipo.codigo} - ${tipo.descricao}`}
                    </option>
                  ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Fabricante*
              </label>
              <div className="relative">
                <select
                  name="marca_id"
                  value={formData.marca_id}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-600 bg-gray-250 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 [color-scheme:light]"
                  style={{ colorScheme: 'light' }}
                  required
                >
                  <option value="0">Selecione</option>
                  {marcas
                    .sort((a, b) => a.descricao.localeCompare(b.descricao))
                    .map((item) => (
                      <option key={item.id} value={item.codigo}>
                        {item.descricao.toUpperCase()}
                      </option>
                    ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Modelo*
              </label>
              <div className="relative">
                <select
                  name="modelo"
                  value={formData.modelo}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-600 bg-gray-250 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 [color-scheme:light]"
                  style={{ colorScheme: 'light' }}
                  required
                >
                  <option value="0">Selecione</option>
                  {modelos
                    .sort((a, b) => a.descricao.localeCompare(b.descricao))
                    .map((item) => (
                      <option key={item.id} value={item.descricao}>
                        {item.descricao.toUpperCase()}
                      </option>
                    ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Descrição/Modelo Completo*
              </label>
              <input
                type="text"
                name="descricao"
                value={formData.descricao}
                onChange={handleChange}
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:italic placeholder:font-light placeholder:text-gray-400 uppercase"
                placeholder="ex: FIAT STRADA 1.8 SL"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Cor*
              </label>
              <input
                type="text"
                name="cor"
                value={formData.cor}
                onChange={handleChange}
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:italic placeholder:font-light placeholder:text-gray-400 uppercase"
                placeholder="ex: BRANCO"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Combustível*
              </label>
              <div className="relative">
                <select
                  name="tipo_combustivel_tl"
                  value={formData.tipo_combustivel_tl}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="0">Selecione</option>
                  {tiposCombustivel.map((combustivel) => (
                    <option key={combustivel.id} value={combustivel.codigo}>
                      {`${combustivel.codigo} - ${combustivel.descricao}`}
                    </option>
                  ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Capacidade do Tanque*
              </label>
              <input
                type="number"
                name="capacidade_tanque"
                value={formData.capacidade_tanque || ''}
                onChange={handleChange}
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:italic placeholder:font-light placeholder:text-gray-400"
                placeholder="ex: 54"
                min="0"
                max="300"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Quilometragem inicial*
              </label>
              <input
                type="number"
                name="km_inicial"
                value={formData.km_inicial || ''}
                onChange={handleChange}
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:italic placeholder:font-light placeholder:text-gray-400"
                placeholder="ex: 202345"
                min="0"
                required
              />
            </div>
          </div>
        </div>

        <div className="bg-gray-300 p-4 rounded-md">
          <h2 className="text-lg font-medium mb-4">Informações de Contrato</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Centro de custo*
              </label>
              <div className="relative">
                <select
                  name="codigo_cc_tl"
                  value={formData.codigo_cc_tl}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-600 bg-gray-250 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 [color-scheme:light]"
                  style={{ colorScheme: 'light' }}
                  required
                >
                  <option value="0">Selecione</option>
                  {centroCustoTicketlog.map((tipo) => (
                    <option key={tipo.codigo} value={tipo.codigo}>
                      {tipo.descricao}
                    </option>
                  ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Tipo de Contrato*
              </label>
              <div className="relative">
                <select
                  name="tipo_frota_tl"
                  value={formData.tipo_frota_tl}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="0">Selecione</option>
                  {tiposContrato
                    .filter((tipo) =>
                      ['LOCADA', 'AGREGADO', 'PROPRIA'].some((termo) =>
                        tipo.descricao.includes(termo)
                      )
                    )
                    .map((tipo) => (
                      <option key={tipo.id} value={`${tipo.codigo}-${tipo.descricao}`}>
                        {tipo.descricao}
                      </option>
                    ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>

            {formData.tipo_frota_tl &&
              String(formData.tipo_frota_tl).includes('LOCADA') && (
                <div>
                  <label className="block text-sm font-medium text-gray-100 mb-1">
                    Locadora*
                  </label>
                  <div className="relative">
                    <select
                      name="locadora_id"
                      value={formData.locadora_id}
                      onChange={handleChange}
                      className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    >
                      <option value="0">Selecione</option>
                      {locadoras.map((tipo) => (
                        <option key={tipo.id} value={tipo.id}>
                          {tipo.nome.toUpperCase()}
                        </option>
                      ))}
                    </select>
                    <CaretDown
                      size={16}
                      className="absolute right-3 top-3 text-gray-500"
                    />
                  </div>
                </div>
              )}

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                {String(formData.tipo_frota_tl).includes('LOCADA', 'AGREGADO')
                  ? 'Valor de Contrato (R$)'
                  : 'Valor de Depreciação (R$)'}
              </label>
              <input
                type="number"
                name="valor_contrato"
                value={formData.valor_contrato || ''}
                onChange={handleChange}
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="0,00"
                step="0.01"
                min="0"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mt-4">
            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Início do Contrato*
              </label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd/MM/yyyy"
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholderText="dd/mm/aaaa"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Fim do Contrato*
              </label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="dd/MM/yyyy"
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholderText="dd/mm/aaaa"
                minDate={startDate}
                required
              />
            </div>
          </div>
        </div>

        <div className="bg-gray-300 p-4 rounded-md">
          <h2 className="text-lg font-medium mb-4">Responsáveis e Situação</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Gestor*
              </label>
              <div className="relative">
                {/* Input de busca */}
                <input
                  type="text"
                  placeholder="Digite para buscar um gestor..."
                  value={filtroResponsavel}
                  onChange={(e) => setFiltroResponsavel(e.target.value)}
                  onFocus={() => setShowDropdownResponsavel(true)}
                  className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 "
                  required
                />

                {/* Dropdown com opções filtradas */}
                {showDropdownResponsavel && (
                  <div className="absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-md shadow-lg z-10 max-h-60 overflow-y-auto">
                    {codigoResponsavelVeiculoTl
                      .filter((responsavel) =>
                        responsavel.descricao
                          .toLowerCase()
                          .includes(filtroResponsavel.toLowerCase())
                      )
                      .slice(0, 100) // Limita a 100 resultados para performance
                      .map((responsavel) => (
                        <div
                          key={responsavel.codigo}
                          className="px-3 py-2 hover:bg-gray-50 cursor-pointer text-gray-900 border-b border-gray-100 last:border-b-0"
                          onClick={() => {
                            setFormData((prev) => ({
                              ...prev,
                              codigo_responsavel_veiculo_tl: responsavel.codigo,
                            }));
                            setFiltroResponsavel(responsavel.descricao);
                            setShowDropdownResponsavel(false);
                          }}
                        >
                          {responsavel.descricao}
                        </div>
                      ))}

                    {/* Mensagem quando não encontra resultados */}
                    {codigoResponsavelVeiculoTl.filter((responsavel) =>
                      responsavel.descricao
                        .toLowerCase()
                        .includes(filtroResponsavel.toLowerCase())
                    ).length === 0 &&
                      filtroResponsavel && (
                        <div className="px-3 py-2 text-gray-500 italic">
                          Nenhum gestor encontrado para "{filtroResponsavel}"
                        </div>
                      )}
                  </div>
                )}

                <CaretDown
                  size={16}
                  className="absolute right-3 top-3 text-gray-500 pointer-events-none"
                />
              </div>

              {/* Mostra o gestor selecionado */}
              {formData.codigo_responsavel_veiculo_tl && (
                <div className="mt-1 text-xs text-gray-400">
                  Código selecionado: {formData.codigo_responsavel_veiculo_tl}
                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Tipo de Restrição*
              </label>
              <div className="relative">
                <select
                  name="codigo_grupo_restricao_tl"
                  value={formData.codigo_grupo_restricao_tl}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="0">Selecione</option>
                  {codigoGrupoRestricaoTl
                    .sort((a, b) => a.descricao.localeCompare(b.descricao))
                    .map((tipo) => (
                      <option key={tipo.id} value={tipo.codigo}>
                        {tipo.descricao}
                      </option>
                    ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Empresa*
              </label>
              <div className="relative">
                <select
                  name="empresa_id"
                  value={formData.empresa_id}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="0">Selecione</option>
                  {empresas.map((empresa) => (
                    <option key={empresa.id} value={empresa.id}>
                      {empresa.nome_empresa}
                    </option>
                  ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Data de Entrega*
              </label>
              <DatePicker
                selected={dataEntrega}
                onChange={(date) => setDataEntrega(date)}
                dateFormat="dd/MM/yyyy"
                className="w-full border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholderText="dd/mm/aaaa"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Data de Devolução*
              </label>
              <DatePicker
                selected={dataDevolucao}
                onChange={(date) => setDataDevolucao(date)}
                dateFormat="dd/MM/yyyy"
                className="w-full border border-gray-300 text-gray-900 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholderText="dd/mm/aaaa"
                minDate={dataEntrega}
                required
              />
            </div>
          </div>
        </div>

        {/* Seção de Rastreador e Cartão */}
        <div className="bg-gray-300 p-4 rounded-md">
          <h2 className="text-lg font-medium mb-4">Rastreador e Tag</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Empresa de Rastreamento
              </label>
              <div className="relative">
                <select
                  name="rastreador_empresa_id"
                  value={formData.rastreador_empresa_id}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="0">Selecione</option>
                  {empresasRastreador.map((empresa) => (
                    <option key={empresa.id} value={empresa.id}>
                      {empresa.nome_empresa}
                    </option>
                  ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-100 mb-1">
                Empresa de Tags
              </label>
              <div className="relative">
                <select
                  name="tag_id"
                  value={formData.tag_id}
                  onChange={handleChange}
                  className="w-full bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="0">Selecione</option>
                  {tags.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.nome.toUpperCase()}
                    </option>
                  ))}
                </select>
                <CaretDown size={16} className="absolute right-3 top-3 text-gray-500" />
              </div>
            </div>
          </div>
        </div>

        {/* Botões */}
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            className="bg-gray-300 text-gray-800 px-6 py-2 rounded-md hover:bg-gray-400 transition-colors"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center"
            disabled={loading}
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Salvando...
              </>
            ) : (
              'Salvar'
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
